import { ICompany } from '@company/company.structures';
import { HttpErrorResponse } from '@angular/common/http';
import { ExceptionService } from '@base/exceptions.service';
import { EMPTY, getNumber } from '@utils';
import { Observable, BehaviorSubject, throwError, of } from 'rxjs';
import { ApplicationHttpClient } from './../http-client';
import { Injectable } from '@angular/core';
import { moduleRoutes } from './urlmap';
import { IModule, IErrorResponse } from '@interfaces';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ModuleService {
  private mapRoutes = moduleRoutes;

  private _module: IModule = EMPTY;
  private bsCurrentModule = new BehaviorSubject<IModule>(this._module);

  private modulesState: IModule[] = [];
  private bsModulesState = new BehaviorSubject<IModule[]>(this.modulesState);

  private companyModulesState: any[] = [];
  private bsCompanyModulesState = new BehaviorSubject<any[]>(this.companyModulesState);

  private fetchingData: boolean;
  private bsFetchingData = new BehaviorSubject<boolean>(this.fetchingData);

  private _company: ICompany = EMPTY;
  private bsCurrentCompany = new BehaviorSubject<ICompany>(this._company);

  constructor(
    private http: ApplicationHttpClient,
    private exceptionService: ExceptionService,
  ) {
    this._module = EMPTY;
    this.fetchingData = false;
  }

  getModules() {
    this.notifyFetching(true);
    return this.http.Get(this.mapRoutes.list).subscribe(
      (res) => {
        this.notifyFetching(false);
        this.modulesState = res['results'];
        this.bsModulesState.next(this.modulesState);
      },
      (err: HttpErrorResponse) => {const error: IErrorResponse = this.exceptionService.errorHandling(err); }
    );
  }

  getModuleCompanies(module: IModule, companies: ICompany[]) {
    if (companies.length > 0) {
      const auxModuleCompanies = [...module.companies];
      const auxCompanies = [...companies];
      let updatedCompanies = [];

      auxModuleCompanies.map((c: ICompany) => {
        const objCo = auxCompanies.find((auxCo: ICompany) => auxCo.id === c.id);
        updatedCompanies = [...updatedCompanies, objCo];
      });

      this.companyModulesState = updatedCompanies;
      this.bsCompanyModulesState.next(this.companyModulesState);
    }
  }

  observeModules(): Observable<IModule[]> {
    return this.bsModulesState.asObservable();
  }

  observeCompanyModules(): Observable<ICompany[]> {
    return this.bsCompanyModulesState.asObservable();
  }

  observeCurrentModule(): Observable<IModule> {
    return this.bsCurrentModule.asObservable();
  }

  observeFetchingData(): Observable<boolean> {
    return this.bsFetchingData.asObservable();
  }

  observeCurrentCompany(): Observable<ICompany> {
    return this.bsCurrentCompany.asObservable();
  }

  setCurrentModule(module: IModule) {
    this._module = module;
    this.bsCurrentModule.next(this._module);
  }

  notifyFetching(fetchingData: boolean) {
    this.fetchingData = fetchingData;
    this.bsFetchingData.next(this.fetchingData);
  }

  setCompany(company: ICompany) {
    this._company = company;
    this.bsCurrentCompany.next(this._company);
  }

  updateCompanyInModules(modules: [], company: ICompany) {
    const auxModulesState = [...this.modulesState];

    modules.map(companyModule => {
      const companyId = getNumber(company.id);
      const moduleId = companyModule['module']['id'];
      const item = {
        id: companyId,
        name: company.name,
        active: companyModule['active'],
      };
      const module = auxModulesState.find(m => m.id === moduleId);

      if (typeof module !== 'undefined') {
        const companyExists = module.companies.some(c => getNumber(c['id']) === companyId);

        if (!companyExists) {
          module.companies = [...module.companies, item];
        }
      }
    });
    this.modulesState = auxModulesState;
    this.bsModulesState.next(this.modulesState);
  }

  filterCompanies(filterParams: object): Observable<ICompany[]> {
    const moduleId = (filterParams.hasOwnProperty('moduleId')) ? filterParams['moduleId'] : 0;
    const userId = (filterParams.hasOwnProperty('userId')) ? filterParams['userId'] : 0;

    if (moduleId > 0) {
      const queryParams: object = {
        order: '-updated_at',
        userId: userId,
      };
      if (userId === 0) {delete queryParams['userId']; }
      const endpoint = `${this.mapRoutes.list}${moduleId}/companies/`;
      return this.http.Get(endpoint, queryParams).pipe(
        map((res) => {
          const companies: ICompany[] = res['results'];
          return companies;
        }),
        catchError((err: HttpErrorResponse) => throwError(err))
      );
    }
    return of([]);
  }

  setCompanies(companies: ICompany[]) {
    this.bsCompanyModulesState.next(companies);
  }
}
